import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
//import PropTypes from 'prop-types'
import LoginForm from '../components/LogInForm.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'

const imgStyle = {
  maxHeight: '100%',
  maxWidth: '100%',
}

const divStyle = {
  display: 'inline-block',
}

const rowStyle = {
  paddingTop: '50px',
}

const logoUrl = 'https://tol-assets.s3.amazonaws.com/assets/logo_big-962c530a875570dafcf5bb30c2ec1df44bddaef77306a156561edc8f2e71c2ed.png'

class LoggedoutRoot extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(location.search)
    const redirectBack = queryParams.get('redirect_back')

    if (redirectBack) {
      sessionStorage.setItem('redirect_back', redirectBack)
      window.location.replace('/')
    }
  }

  render() {
    return <Fragment><div style={rowStyle} className="row"><div style={divStyle} className="col-md-5"><img src={logoUrl} style={imgStyle} /></div><div style={divStyle} className="col-md-5 offset-md-2"><LoginForm></LoginForm></div></div></Fragment>
  }
}

export default LoggedoutRoot
